<template>
        <div class="flex flex-col w-full lg:w-1/2">
            <Form title="Credit Union Info"
                submitText="Update CU Info"
                :showCancel="true"
                @cancel="this.$router.push('/adminmn/filist')"
                @submit="saveSettings">
                <div class="w-full flex flex-row flex-wrap gap-y-4">
                    <div class="w-full p-2 mn3-header">Main CU Info</div>
                    <Field type="text" class="w-1/2"                 
                        :formValue="fv.title"
                        label="Title" />
                    <Field type="text" class="w-1/2"                 
                        :formValue="fv.address1"
                        label="Address" />
                    <Field type="text" class="w-1/2"                 
                        :formValue="fv.city"
                        label="City" />
                    <Field type="text" class="w-1/2"                 
                        :formValue="fv.state"
                        label="State" />
                    <Field type="text" class="w-1/2"                 
                        :formValue="fv.zipCode"
                        label="zipCode" />
                    <Field type="text" class="w-1/2"                 
                        :formValue="fv.phone"
                        label="phone" />
                    <Field type="text" class="w-1/2"                 
                        :formValue="fv.rtn"
                        label="rtn" />
                </div>
                <div class="w-full flex flex-row flex-wrap">
                    <div class="w-full p-2 mn3-header">System Settings</div>
                    <Field type="text" class="w-1/2"
                        label="CUFX Env"              
                        :formValue="fv.cufxEnv" />
                    <Field type="text" class="w-1/2"
                        label="CUFX FI ID"               
                        :formValue="fv.cufxFiId"/>
                    <Field type="text" class="w-1/2"
                        label="Host Name"              
                        :formValue="fv.hostname" />
                    <Field type="text" class="w-1/2"
                        label="Session Timeout"               
                        :formValue="fv.sessionTimeout"/>
                    <Field type="text" class="w-1/2"
                        label="System"              
                        :formValue="fv.system" />
                    <Field type="text" class="w-1/2"
                        label="Email From Address"              
                        :formValue="fv.emailFromAddress" />
                    <Field type="text" class="w-1/2"
                        label="Links Page Title"              
                        :formValue="fv.linksPageTitle" />
                    <Field type="text" class="w-1/2"
                        label="Loan Advance Grace Days"               
                        :formValue="fv.loanAdvanceGraceDays"/>
                    <Field type="textarea" class="w-full"
                        label="Login Instructions"              
                        :formValue="fv.loginInstructions" />
                </div>
                
                
                <div class="w-full flex flex-row flex-wrap">
                    <div class="w-full p-2 mn3-secondary">Features</div>
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.addressChangeEnabled"
                        label="Address Change"          
                         />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.addressChangeMessageEnabled"
                        label="Address Change Message" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.alertsEnabled"
                        label="Alerts" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.allied2Enabled"
                        label="Allied2" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.alliedEnabled"
                        label="Allied" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.alloyaEnabled"
                        label="Alloya" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.boardpacketEnabled"
                        label="Board Packet" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.cardStatusEnabled"
                        label="Card Status" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.ccpaymentEnabled"
                        label="CC Payment" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.corpamericaEnabled"
                        label="Corp America" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.fiservciEnabled"
                        label="FI Servici" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.fissendpointEnabled"
                        label="FI Send Point" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.ipayEnabled"
                        label="iPay" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.jointRegistrationEnabled"
                        label="Joint Registration" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.linksPageEnabled"
                        label="Links Page" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.linksPageGroupsEnabled"
                        label="Links Page Groups" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.loanappEnabled"
                        label="Loan App" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.messagingEnabled"
                        label="Messaging" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.millenniumEnabled"
                        label="Millennium" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.mobileChangeMessageEnabled"
                        label="Mobile Change Message" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.mycuservicesEnabled"
                        label="My CU Services" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.neuralpayEnabled"
                        label="Neural Pay" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.noticesEnabled"
                        label="Notices Enabled" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.principalOnlyPaymentsEnabled"
                        label="Principal Only Payments" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.rdcEnabled"
                        label="RDC" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.recurringEnabled"
                        label="Recurring" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.statementsEnabled"
                        label="Statements" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.transferToCcEnabled"
                        label="Transfer to CC" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.transferToCheckEnabled"
                        label="Transfer to Check" />
                    <Field type="toggle" class="w-1/4"
                        :formValue="fv.origenceLoanappSsoEnabled"
                        label="Origence Enabled" />
                </div>
                
            </Form>
        </div>           

</template>

<script>
	import Form from "@/components/Form.vue";
	import Field from "@/components/Field.vue";
    import { ref } from 'vue'
    import { useRouter } from "vue-router"

	export default {
		components:{
			Form,
			Field
		},
		data(){
			return {
			};
		},
        methods: {
            async fetchSettings(fid){
                let fetched = await this.$rapi.get("fis/" + fid);
                this.fis = fetched['data']['data'];
                console.log('fetchSettings: ', this.fis);

                let loadedSettings = this.fis.attributes
                for(var key in this.fv){
                    if(loadedSettings[key])
                        this.fv[key].value = loadedSettings[key] == 'true' || loadedSettings[key] && key.indexOf('Enabled') != -1 ? 'Y' : loadedSettings[key]
                    else
                    console.log('setting not found: ', key)
                }
//                this.fv.title.value = loadedSettings.title
            },
            async saveSettings(){
                let data = {
                    "data": {
                        "attributes": { }
                    }
                }
                for(var key in this.fv){
                        data.data.attributes[key] = this.fv[key].value == 'N' ? false : this.fv[key].value == 'Y' ? true : this.fv[key].value;

                        //Check for settings that need to be converted to a number
                        if(key == 'loanAdvanceGraceDays' || key == 'sessionTimeout'){
                            data.data.attributes[key] = parseInt(data.data.attributes[key]);
                        }
                }
                let postUrl = this.fis.links.self

                console.log('save settings: ', data, postUrl);
                try{
                    let resp = await this.$rapi.patch(postUrl, data); 
                    console.log('resp: ', resp);
                    this.$router.push('filist')
                }catch(resp){
                    let errorDetail = resp.response.data.errors[0].detail;
                    let errorTitle = resp.response.data.errors[0].title;
                    if(errorDetail != undefined){
                        this.error = 'Error: ' + errorDetail;
                    }else if(errorTitle != undefined){
                        this.error = 'Error: ' + errorTitle;
                    }else{
                        this.error = 'Error: There was an issue saving the link';
                    }
                }
            }
        },
		created(){
    let fid = this.$route.query.id;
    this.fetchSettings(fid);
		}, 

        setup(){
            
            let error = ref('')
			/* Form field values */
			let fv = {}
            fv["addressChangeEnabled"] = ref("N");
            fv["addressChangeMessageEnabled"] = ref("N");
            fv["alertsEnabled"] = ref("N");
            fv["allied2Enabled"] = ref("N");
            fv["alliedEnabled"] = ref("N");
            fv["alloyaEnabled"] = ref("N");
            fv["boardpacketEnabled"] = ref("N");
            fv["cardStatusEnabled"] = ref("N");
            fv["ccpaymentEnabled"] = ref("N");
            fv["corpamericaEnabled"] = ref("N");
            fv["fiservciEnabled"] = ref("N");
            fv["fissendpointEnabled"] = ref("N");
            fv["ipayEnabled"] = ref("N");
            fv["jointRegistrationEnabled"] = ref("N");
            fv["linksPageEnabled"] = ref("N");
            fv["linksPageGroupsEnabled"] = ref("N");
            fv["loanappEnabled"] = ref("N");
            fv["messagingEnabled"] = ref("N");
            fv["millenniumEnabled"] = ref("N");
            fv["mobileChangeMessageEnabled"] = ref("N");
            fv["mycuservicesEnabled"] = ref("N");
            fv["neuralpayEnabled"] = ref("N");
            fv["noticesEnabled"] = ref("N");
            fv["principalOnlyPaymentsEnabled"] = ref("N");
            fv["rdcEnabled"] = ref("N");
            fv["recurringEnabled"] = ref("N");
            fv["statementsEnabled"] = ref("N");
            fv["transferToCcEnabled"] = ref("N");
            fv["transferToCheckEnabled"] = ref("N");
            fv["origenceLoanappSsoEnabled"] = ref("N");
            
            fv["title"] = ref("");
            fv["address1"] = ref("");
            fv["city"] = ref("");
            fv["state"] = ref("");
            fv["zipCode"] = ref("");
            fv["phone"] = ref("");
            fv["rtn"] = ref("");
            fv["cufxEnv"] = ref("");
            fv["cufxFiId"] = ref("");
            fv["hostname"] = ref("");
            fv["sessionTimeout"] = ref("");
            fv["system"] = ref("");
            fv["emailFromAddress"] = ref("");
            fv["linksPageTitle"] = ref("");
            fv["loginInstructions"] = ref("");
            fv["loanAdvanceGraceDays"] = ref("");
            
            return { 
                error,
				fv
            }

        }
	}
	
</script>
